import React from "react"
import { Link } from 'react-router-dom'

export default () => {
  return <div className="darkest-gray-transparent-box p-d">
           <Link to={ "/" }> Schedule </Link>
         </div>
}
